import type { ReactNode } from 'react';

/**
 * STITCH-2 designed empty state (03 P11; DESIGN DIRECTION law (c)): the
 * queue's OWN plain-language copy on a calm tint -- never a bare "no data",
 * never a blank hole. Optional action slot for the one obvious next step.
 */
export interface EmptyStateProps {
  readonly icon?: ReactNode;
  readonly title: string;
  readonly body?: ReactNode;
  readonly action?: ReactNode;
  readonly testId?: string;
}

export default function EmptyState({
  icon,
  title,
  body,
  action,
  testId,
}: EmptyStateProps) {
  return (
    <div className="ac-empty" data-testid={testId}>
      {icon ? <span className="ac-empty__icon">{icon}</span> : null}
      <p className="ac-empty__title">{title}</p>
      {body ? <p className="ac-empty__body">{body}</p> : null}
      {action ?? null}
    </div>
  );
}
